module.exports = __webpack_public_path__ + "static/media/chra-kelbi.ff6213a8.mp3";